<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t(type) }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && !id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="create"
            :loading="isLoading"
          >
            <v-icon
              color="green"
              style="font-size: 22px"
            >
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('submit') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="update"
          >
            <v-icon
              color="green"
              style="font-size: 22px"
            >
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('submit') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showCurrency = !showCurrency"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              {{ (showCurrency ? 'mdi-currency-usd' : 'mdi-currency-usd-off') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('showCurrency') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="(printType == 'normal' ? printType = 'fish' : printType = 'normal')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              {{ (printType == 'normal' ? 'mdi-printer-outline' : 'mdi-paper-roll-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ (printType == 'normal' ? $t('normalPrint') : $t('invoiceRollprint')) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('newRow') }} (f2)</span>
      </v-tooltip>
      <v-tooltip
        v-if="selected.length > 0"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon
              color="pink"
              style="font-size: 22px"
            >
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('remove') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showProductList = !showProductList"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              {{ (showProductList ? 'mdi-file-table-box-outline' : 'mdi-table-large') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('productList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( type + 'List' )"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('list') }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t('public-information') }}
        </v-tab>
        <v-tab>{{ $t('otherInputs') }}</v-tab>
        <v-tab v-if="$store.state.allConfig && $store.state.allConfig.commissionSystem == 'active'">
          {{ $t('commission') }}
        </v-tab>
        <v-tab
          :disabled="documentPermmission"
        >
          {{ $t('documents') }}
        </v-tab>
        <v-tab
          v-if="type === 'purchase'"
          :disabled="investorPermmission"
        >
          {{ $t('investors') }}
        </v-tab>
        <v-tab-item>
          <v-container
            class="py-0 px-1"
            fluid
          >
            <v-row class="my-2 mx-0 px-0">
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="number"
                  height="20"
                  dense
                  :rules="[v => !!v || $t('is-required')]"
                  outlined
                  class="mb-3 dense"
                  clearable
                  :label="$t('number')"
                  @blur="getInvoiceNumber"
                />
              </v-col>
              <v-col
                class="px-1 xs py-1"
                cols="12"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                md="2"
                sm="2"
              >
                <autocomplete
                  ref="refAccount"
                  v-model="account"
                  :title="(type === 'purchase' || type === 'returnPurchase' ? $t('detailsInvoice') : $t('customer'))"
                  type="person"
                  :new-btn="true"
                  :value="account"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                class="px-1 xs py-1"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                cols="12"
                md="2"
                sm="2"
              >
                <autocomplete
                  ref="refEntrepot"
                  v-model="entrepot"
                  title="entrepot"
                  type="entrepot"
                  :set-init="(id ? false : true)"
                  :new-btn="true"
                  :value="entrepot"
                  @input="checkProductsCount"
                />
              </v-col>
              <v-col
                class="py-1 px-1"
                cols="12"
                md="2"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                sm="2"
              >
                <template>
                  <v-text-field
                    id="from"
                    v-model="date"
                    :label="$t('date')"
                    :rules="[v => !!v || $t('is-required')]"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />
                  <date-picker
                    v-model="date"
                    element="from"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                class="py-1 px-1"
              >
                <aicomplete
                  v-model="branch"
                  title="branch"
                  type="branch"
                  :set-init="true"
                  :val="branch"
                  :new-btn="true"
                />
              </v-col>
              <v-col
                v-show="(type == 'presale' || type == 'sell'|| type == 'returnSell') && (bodyStatus == false || !$vuetify.breakpoint.mobile)"
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="officialNumber"
                  height="20"
                  dense
                  outlined
                  class="mb-3 dense"
                  clearable
                  :label="$t('officialNumber')"
                  @blur="getOfficialInvoiceNumber"
                />
              </v-col>
            </v-row>
            <v-row
              class="my-2 mb-6 mx-0 px-0"
              v-if="taxPayerSystem && type === 'sell'"
            >
              <v-col
                cols="12"
                md="2"
                sm="2"
                class="py-1 px-1"
              >
                <v-select
                  v-model="pattern"
                  :label="$t('invoiceType')"
                  :items="invoiceTypeItems"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="2"
                class="py-1 px-1"
              >
                <v-select
                  v-model="invoicePattern"
                  :label="$t('invoicePattern')"
                  :items="patternItems"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                />
              </v-col>
              <v-col
                v-show="invoicePattern === '4'"
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="contractNumber"
                  height="20"
                  dense
                  outlined
                  class="mb-3 dense"
                  clearable
                  :label="$t('contractNumber')"
                />
              </v-col>
            </v-row>
            <v-row class="mt-4 mx-0">
              <v-col
                v-if="showProductList"
                v-show="bodyStatus == true || !$vuetify.breakpoint.mobile"
                cols="4"
                class="px-1 py-0 "
              >
                <products
                  v-model="items"
                  :data="JSON.stringify({entrepot : (entrepot ? entrepot.id : null)})"
                  @append="append"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == true || !$vuetify.breakpoint.mobile"
                :cols="(showProductList ? 8 : 12)"
                class="px-0 py-0 border-datatable"
              >
                <v-data-table
                  v-if="headers"
                  v-model="selected"
                  fixed-header
                  :headers="showHeaders"
                  :items="items"
                  :height="tableHeightInvoice"
                  :options.sync="tableOptions"
                  :server-items-length="totalItems"
                  :loading="loading"
                  multi-sort
                  class="mx-1"
                  style="border-left: 1px solid #e3e3e3;border-right: 1px solid #e3e3e3"
                  dense
                  :show-select="showSelect"
                  hide-default-footer
                  item-key="id"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:item.row="{ item }">
                    {{ parseInt(items.indexOf(item))+ parseInt(from) }}
                  </template>
                  <template v-slot:item.content="{ item }">
                    <v-text-field
                      v-model="item.content"
                      height="20"
                      dense
                      solo
                      flat
                      class="mb-3 dense"
                      :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                      clearable
                      :placeholder="$t('content')"
                    />
                  </template>
                  <template v-slot:item.product="{ item , index }">
                    <autocomplete
                      v-if="(type == 'purchase' || type == 'returnSell' ? true : (entrepot ? true : (id && item.product ? true :true)))"
                      :ref="'refProduct' + parseInt(items.indexOf(item))"
                      v-model="item.product"
                      class="mb-3"
                      :rules="[v => !!v || $t('is-required')]"
                      type="productService"
                      :data="JSON.stringify({entrepot:(entrepot ? entrepot.id : null)})"
                      :new-btn="true"
                      :value="item.product"
                      :type-prop="type"
                      @clear="clearRow(item)"
                      @input="changeProduct(item, index)"
                    />
                  </template>
                  <template v-slot:item.entrepot="{ item , index }">
                    <autocomplete
                      v-model="item.article_entrepot"
                      class="mb-3"
                      type="entrepot"
                      :getInitItemsOff="true"
                      @input="changeEntrepotAtRow(item, index)"
                    />
                  </template>
                  <template v-slot:item.unit="{ item }">
                    <v-select
                      v-model="item.unit"
                      :items="unitItems(item)"
                      height="30"
                      dense
                      class="mb-3"
                      outlined
                      return-object
                      item-value="id"
                      item-text="fame"
                    />
                  </template>
                  <template v-slot:item.fee="{ item }">
                    <money
                      v-model="item.fee"
                      :dense="true"
                      :outlined="true"
                      :rules="[feeValidate]"
                      :solo="false"
                      :clearable="true"
                      value-when-is-empty=""
                      :options="options"
                      :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                      class="mb-3 dense"
                      @input="calcSum"
                    />
                  </template>
                  <template v-slot:item.count="{ item }">
                    <div class="d-flex">
                      <v-menu
                        open-on-hover
                        top
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.count"
                            v-disabled-icon-focus
                            v-bind="attrs"
                            height="20"
                            dense
                            solo
                            hide-details
                            flat
                            class="mb-3 dense"
                            :rules="[v => !!v || $t('is-required')]"
                            :suffix="(item.unit ? item.unit.fame : '')"
                            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                            :placeholder="$t('count')"
                            type="number"
                            v-on="on"
                            @blur="zeroCountCheck(item)"
                            @input="checkCount(item)"
                            @focus="focusEvent"
                          />
                        </template>
                        <v-list
                          dense
                          v-if="item.product"
                        >
                          <v-list-item>
                            <v-list-item-title>{{$t('entrepotStock')}} : {{ (item.product && item.product.stock ? item.product.stock.count : 0) }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>{{$t('reservedCount')}} : {{ (item.product && item.product.reserved ? item.product.reserved.stock + '' : 0) }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>{{$t('remain')}} : {{ (item.product ? item.product.remain : 0) }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-show="item.product && item.product.kind_id === 112"
                            v-bind="attrs"
                            small
                            outlined
                            color="primary"
                            style="margin-right: 2px !important;margin-top: 1px;"
                            v-on="on"
                            @click="openGoldDialog(item)"
                          >
                            <v-icon
                              style="font-size: 22px"
                            >
                              mdi-gold
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('goldCalculator') }}</span>
                      </v-tooltip>
                      <p
                        v-if="item.product && unitItems(item).length > 1 && unitCalc(item) !== 1"
                        style="min-width: 80px"
                        class="px-2 px-2 pt-2 my-0"
                      >
                        = {{ item.count*unitCalc(item) }} {{ unitItems(item)[0].fame }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.discount="{ item }">
                    <div class="d-flex">
                      <money
                        v-model="item.discount"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty=""
                        :options="options"
                        class="mb-3 dense"
                        :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : (item.fee*item.count > 0 ? false : true))"
                        @input="checkDiscount(item)"
                      />
                      <v-text-field
                        v-model="item.discountPercent"
                        v-disabled-icon-focus
                        height="20"
                        dense
                        flat
                        outlined
                        solo
                        suffix="%"
                        class="mb-2 dense ms-1"
                        style="max-width: 80px"
                        type="number"
                        :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                        @focus="focusEvent"
                        @input="checkDiscountPercent(item)"
                      />
                    </div>
                  </template>
                  <template v-slot:item.tax="{ item }">
                    <div class="d-flex">
                      <money
                        v-model="item.tax"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        value-when-is-empty=""
                        :options="options"
                        class="mb-3 dense"
                        :disabled="true"
                      />
                      <v-text-field
                        v-if="item.product"
                        v-model="item.product.tax_percent"
                        v-disabled-icon-focus
                        height="20"
                        dense
                        flat
                        outlined
                        solo
                        suffix="%"
                        class="mb-2 dense ms-1"
                        style="max-width: 80px"
                        type="number"
                        @focus="focusEvent"
                        @input="calcSum"
                      />
                    </div>
                  </template>
                  <template v-slot:item.sum="{ item }">
                    {{ $numberFormat((parseFloat(item.fee * item.count * ((item.cutie && item.cutie !== 0 && item.cutie !== '0' ? item.cutie/750 : 1)).toFixed(2)) + parseFloat((item.tax || 0)) - parseFloat((item.discount || 0)) + parseFloat((item.construction_wages || 0)) + parseFloat((item.profit || 0)) + parseFloat((item.commission || 0))).toFixed(decimal) ) }}
                  </template>
                  <template v-slot:item.expire_date="{ item, index }">
                    <v-text-field
                      :id="'expireDate' + index"
                      v-model="item.expire_date"
                      clear-icon="flaticon2-close-cross"
                      outlined
                      dense
                      height="25"
                      class="mb-3"
                      clearable
                    />
                    <date-picker
                      v-model="item.expire_date"
                      :element="'expireDate' + index"
                      :locale="$store.state.date_locale"
                      :format="$store.state.date_format"
                      auto-submit
                      :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    />
                  </template>
                  <template
                    v-slot:footer
                  >
                    <v-row class="mt-1 mb-7 mx-1">
                      <v-col
                        cols="12"
                        class="py-0 pr-0"
                      >
                        <v-container class="pa-0 d-flex align-center gap-2 wrapper">
                          <v-btn
                            color="primary"
                            outlined
                            height="45"
                            v-shortkey="['f2']"
                            @shortkey="addRow()"
                            @click="addRow()"
                          >
                            <v-icon>mdi-plus</v-icon>
                            <span>{{ $t('add-new-row') }}</span>
                          </v-btn>
                          <description
                            ref="refContent"
                            v-model="content"
                            class="mt-1 mb-3 description"
                            type="purchase"
                          />
                        </v-container>
                        <v-container
                          class="pa-0 d-flex gap-2 mt-2"
                          :style="{ 'flex-direction': isMobile || isTablet ? 'column' : 'none' }"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th
                                  style="border-top : 1px solid #e3e3e3 !important;"
                                >
                                  <div class="d-flex justify-start">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-shortkey="['f2']"
                                          v-bind="attrs"
                                          icon
                                          small
                                          class="float-left"
                                          @shortkey="addRow()"
                                          v-on="on"
                                          @click="addRow()"
                                        >
                                          <v-icon
                                            color="teal"
                                            style="font-size: 22px"
                                          >
                                            mdi-plus-box-outline
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span>{{ $t('newRow') }} (f2)</span>
                                    </v-tooltip>
                                  <!--                                  <v-tooltip bottom>-->
                                  <!--                                    <template v-slot:activator="{ on, attrs }">-->
                                  <!--                                      <v-btn-->
                                  <!--                                        v-shortkey="['f2']"-->
                                  <!--                                        v-bind="attrs"-->
                                  <!--                                        icon-->
                                  <!--                                        small-->
                                  <!--                                        class="float-left"-->
                                  <!--                                        :disabled="(selected.length > 0 ? false : true)"-->
                                  <!--                                        @shortkey="openDeleteDialogVerify()"-->
                                  <!--                                        v-on="on"-->
                                  <!--                                        @click="openDeleteDialogVerify()"-->
                                  <!--                                      >-->
                                  <!--                                        <v-icon-->
                                  <!--                                          color="pink"-->
                                  <!--                                          style="font-size: 22px"-->
                                  <!--                                        >-->
                                  <!--                                          mdi-trash-can-outline-->
                                  <!--                                        </v-icon>-->
                                  <!--                                      </v-btn>-->
                                  <!--                                    </template>-->
                                  <!--                                    <span>{{ $t('remove') }} (f2)</span>-->
                                  <!--                                  </v-tooltip>-->
                                  </div>
                                </th>
                                <th style="border-top : 1px solid #e3e3e3 !important;width: 100px">
                                  {{ $t('sumItem') }} : {{ $numberFormat(totalCount) }}
                                </th>
                                <th style="border-top : 1px solid #e3e3e3 !important;width: 300px">
                                  {{ $t('sum') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td rowspan="2">
                                  <v-col
                                    class="pb-0 pt-0"
                                    cols="12"
                                  >
                                    <description
                                      ref="refContent"
                                      v-model="content"
                                      class="mt-1 mb-3"
                                      type="purchase"
                                    />
                                  </v-col>
                                </td>
                                <td>{{ $t('amount') }}</td>
                                <td>{{ $numberFormat(+total - +totalTax + +discount) }}</td>
                              </tr>
                              <tr>
                                <td style="background: antiquewhite;">
                                  {{ $t('discount') }}
                                </td>
                                <td
                                  style="background: antiquewhite"
                                  :class="{'d-flex' : percentDiscountStatus}"
                                >
                                  <money
                                    v-model="discount"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    :clearable="true"
                                    value-when-is-empty="0"
                                    :options="options"
                                    class="mb-3 dense"
                                    :append-icon="(!percentDiscountStatus ? 'mdi-percent-outline' : null)"
                                    :disabled="(sum > 0 ? (percentDiscountStatus ? true : false) : true)"
                                    @append="discountChangeStatus"
                                    @input="checkTotalDiscount"
                                  />
                                  <v-text-field
                                    v-if="percentDiscountStatus"
                                    v-model="discountPercent"
                                    append-icon="mdi-currency-usd"
                                    placeholder="%"
                                    class="ms-1"
                                    height="20"
                                    outlined
                                    dense
                                    type="number"
                                    max="100"
                                    min="0"
                                    @keyup="discountCheck"
                                    @blur="discountCheck"
                                    @click:append="discountChangeStatus"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="d-flex"
                                  style="height: 48px !important;padding: 0px 10px !important;"
                                >
                                  <div class="d-flex my-2">
                                    <v-checkbox
                                      v-model="taxStatus"
                                      class="mt-0 mb-0 mx-1"
                                      :label="$t('tax')"
                                      value="active"
                                      hide-details
                                    />
                                    <v-text-field
                                      v-if="taxStatus"
                                      v-model="taxPercent"
                                      :label="$t('taxPercent')"
                                      append-icon="mdi-percent-outline"
                                      outlined
                                      style="width: 135px;min-width: 135px;display: none"
                                      dense
                                      :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                                      hide-details
                                      type="number"
                                      clearable
                                    />
                                    <v-checkbox
                                      v-if="showClearing"
                                      v-model="clearingStatus"
                                      class="mt-0 mb-0 mx-1 ms-9"
                                      :label="$t('clearing')"
                                      value="active"
                                      hide-details
                                    />
                                    <autocomplete
                                      v-if="clearingStatus"
                                      ref="refBank"
                                      v-model="bank"
                                      class="ms-2"
                                      style="min-width: 150px"
                                      :title="$t('bank') + '/' + $t('cash')"
                                      :currency-prop="currency.id"
                                      type="bankCash"
                                    />
                                    <v-btn
                                      v-if="bank && clearingStatus && (type == 'sell' || type == 'presale') && bank.pos"
                                      small
                                      outlined
                                      height="32"
                                      style="margin-right: 3px !important;"
                                      color="teal"
                                      @click="sendPriceToPOS(bank.pos, total)"
                                    >
                                      <v-icon
                                        color="teal"
                                        style="font-size: 22px"
                                      >
                                        mdi-point-of-sale
                                      </v-icon>
                                      {{ $t('sendPriceToPOS') }}
                                    </v-btn>
                                    <v-chip
                                      v-if="bank && clearingStatus && type == 'purchase'"
                                      class="ms-2 "
                                      color="primary"
                                      label
                                      outlined
                                      hide-details
                                    >
                                      {{ $t('remain') }}   {{ $t('bank') + '/' + $t('cash') }} : {{ $numberFormat(parseFloat(bank.remain.remain)) }} {{ (currency ? currency.name : '') }}
                                    </v-chip>
                                    <v-chip
                                      v-if="type !== 'purchase'"
                                      class="mx-0 ms-1 ml-1"
                                      label
                                      color="primary"
                                      style="width: 100%"
                                      outlined
                                    >
                                      {{ $t('remain') }}   {{ $t('customer') }} : {{ $numberFormat(parseFloat((personInfo && personInfo.remain ? personInfo.remain.remain : 0))) }} {{ (currency ? currency.name : '') }}
                                    </v-chip>
                                  </div>
                                </td>
                                <td style="background: aliceblue;">
                                  {{ $t('tax') }}
                                </td>
                                <td style="background: aliceblue;">
                                  {{ $numberFormat(totalTax) }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-col
                                    v-if="payments"
                                    class="py-0"
                                  >
                                    <v-chip
                                      v-for="(item,key) in payments"
                                      :key="key"
                                      class="ma-2 my-1 mt-0"
                                      :close="(!item.chip ? false : true)"
                                      color="blue"
                                      outlined
                                      label
                                      @click:close="(item.payments.lock === null ? item.chip = false : item.chip = true)"
                                    >
                                      {{ $t(item.payments.type) }}
                                      - {{ $t('amount') }} : {{ $numberFormat(parseFloat(item.payments.amount)) }}  {{ item.payments.currency.symbol }}
                                      - {{ $t('number') }}  : {{ item.payments.id }}
                                      <v-icon
                                        v-if="!item.chip"
                                        color="green"
                                        class="mx-2"
                                        @click="item.chip = true"
                                      >
                                        mdi-refresh
                                      </v-icon>
                                      <v-icon
                                        v-if="!item.chip && item.payments.lock === null"
                                        color="pink"
                                      >
                                        mdi-trash-can-outline
                                      </v-icon>
                                      <v-icon
                                        v-if="item.payments && item.payments.lock === 'active'"
                                        color="pink"
                                        class="ms-2"
                                      >
                                        mdi-lock-outline
                                      </v-icon>
                                    </v-chip>
                                  </v-col>
                                  <v-col
                                    v-if="checks"
                                    class="py-0"
                                  >
                                    <v-chip
                                      v-for="(item,key) in checks"
                                      :key="key"
                                      class="ma-2 my-1 mt-0"
                                      :close="(!item.chip ? false : true)"
                                      color="deep-orange"
                                      outlined
                                      label
                                      @click:close="(item.checks.lock === null ? item.chip = false : item.chip = true)"
                                    >
                                      {{ $t('check') }} {{ $t(item.checks.type) }}
                                      - {{ $t('amount') }} : {{ $numberFormat(parseFloat(item.checks.amount)) }}  {{ item.checks.currency.symbol }}
                                      - {{ $t('number') }}  : {{ item.checks.number }}
                                      <v-icon
                                        v-if="!item.chip"
                                        color="green"
                                        class="mx-2"
                                        @click="item.chip = true"
                                      >
                                        mdi-refresh
                                      </v-icon>
                                      <v-icon
                                        v-if="!item.chip && !item.checks.lock"
                                        color="pink"
                                      >
                                        mdi-trash-can-outline
                                      </v-icon>
                                      <v-icon
                                        v-if="item.checks && item.checks.lock === 'active'"
                                        color="pink"
                                        class="ms-2"
                                      >
                                        mdi-lock-outline
                                      </v-icon>
                                    </v-chip>
                                  </v-col>
                                  <!--                                  <v-row>-->
                                  <!--                                    <v-btn-->
                                  <!--                                      color="primary"-->
                                  <!--                                      @click="paymentDialog = true"-->
                                  <!--                                      small-->
                                  <!--                                    >-->
                                  <!--                                      افزودن دریافت جدید-->
                                  <!--                                    </v-btn>-->
                                  <!--                                  </v-row>-->
                                </td>
                                <td>{{ $t('total') }}</td>
                                <td>
                                  {{ $numberFormat(total) }}
                                </td>
                              </tr>
                            </tbody>
                          </template>

                          <div>
                            <v-container class="pa-0 d-flex align-center gap-2">
                              <v-btn
                                color="success"
                                :height="isMobile || isTablet ? auto : 55"
                                :width="isMobile || isTablet ? auto : 138"
                                @click="openOptionsDialog('cash-format')"
                              >
                              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.32812 13V5.5C2.32812 5.10218 2.48616 4.72064 2.76746 4.43934C3.04877 4.15804 3.4303 4 3.82812 4H15.8281C16.2259 4 16.6075 4.15804 16.8888 4.43934C17.1701 4.72064 17.3281 5.10218 17.3281 5.5V13C17.3281 13.3978 17.1701 13.7794 16.8888 14.0607C16.6075 14.342 16.2259 14.5 15.8281 14.5H3.82812C3.4303 14.5 3.04877 14.342 2.76746 14.0607C2.48616 13.7794 2.32813 13.3978 2.32812 13Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M14.7031 9.2575L14.7106 9.24925M4.95312 9.2575L4.96063 9.24925M9.82812 11.5C9.23139 11.5 8.65909 11.2629 8.23713 10.841C7.81518 10.419 7.57812 9.84674 7.57812 9.25C7.57812 8.65326 7.81518 8.08097 8.23713 7.65901C8.65909 7.23705 9.23139 7 9.82812 7C10.4249 7 10.9972 7.23705 11.4191 7.65901C11.8411 8.08097 12.0781 8.65326 12.0781 9.25C12.0781 9.84674 11.8411 10.419 11.4191 10.841C10.9972 11.2629 10.4249 11.5 9.82812 11.5Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <span class="mr-1">{{ compositeType == 'recieve'  ? $t('recieve-cash') : $t('payCash') }}</span>
                              </v-btn>
                              <v-btn
                                color="primary"
                                outlined
                                :height="isMobile || isTablet ? auto : 55"
                                :width="isMobile || isTablet ? auto : 138"
                                disabled
                              >
                              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.0095 12.3985L12.6313 2.776M14.474 8.542L12.824 10.192M11.4163 11.5825L10.682 12.3168M3.5 16.75H15.5M2.88125 12.3558C2.60187 12.0765 2.38024 11.7449 2.22903 11.3799C2.07783 11.015 2 10.6238 2 10.2288C2 9.83371 2.07783 9.44254 2.22903 9.07759C2.38024 8.71263 2.60187 8.38104 2.88125 8.10175L8.35175 2.63125C8.63104 2.35187 8.96263 2.13024 9.32759 1.97903C9.69254 1.82783 10.0837 1.75 10.4788 1.75C10.8738 1.75 11.265 1.82783 11.6299 1.97903C11.9949 2.13024 12.3265 2.35187 12.6058 2.63125L16.1188 6.14425C16.3981 6.42354 16.6198 6.75513 16.771 7.12009C16.9222 7.48504 17 7.87621 17 8.27125C17 8.66629 16.9222 9.05746 16.771 9.42242C16.6198 9.78738 16.3981 10.119 16.1188 10.3983L10.6483 15.8688C10.369 16.1481 10.0374 16.3698 9.67242 16.521C9.30746 16.6722 8.91629 16.75 8.52125 16.75C8.12621 16.75 7.73504 16.6722 7.37009 16.521C7.00513 16.3698 6.67354 16.1481 6.39425 15.8688L2.88125 12.3558Z" stroke="silver" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <span class="mr-1">{{ $t('send-to-pos') }}</span>
                              </v-btn>
                              <composite
                                @update="onTableUpdate"
                                :totalTax="totalTax"
                                :discount="discount"
                                :total="total"
                                :account="account"
                                :optionDialogType="optionDialogType"
                                @closeOptionsDialog="optionDialogType = null"
                                @totalAmount="totalAmount"
                                @invoiceRemain="invoiceRemain"
                                :propType="compositeType"
                                :propDate="date"
                                :isInvoiceCreated="isInvoiceCreated"
                                :editCompositeTableData="editCompositeTableData"
                                :currency="currency"
                              />
                            </v-container>
                            <v-container class="pa-0 d-flex align-center gap-2 mt-2">
                              <v-btn
                                v-if="!id"
                                color="primary"
                                :height="isMobile || isTablet ? auto : 55"
                                :width="isMobile || isTablet ? auto : 138"
                                :loading="isLoading"
                                @click="create"
                              >
                              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.0744 5.25C14.8755 5.25 14.6847 5.32902 14.5441 5.46967C14.4034 5.61032 14.3244 5.80109 14.3244 6V9C14.3244 9.19891 14.2454 9.38968 14.1047 9.53033C13.9641 9.67098 13.7733 9.75 13.5744 9.75H6.38188L7.35689 8.7825C7.49811 8.64127 7.57745 8.44973 7.57745 8.25C7.57745 8.05027 7.49811 7.85873 7.35689 7.7175C7.21566 7.57627 7.02411 7.49693 6.82439 7.49693C6.62466 7.49693 6.43311 7.57627 6.29189 7.7175L4.04189 9.9675C3.9736 10.0388 3.92008 10.1229 3.88439 10.215C3.80937 10.3976 3.80937 10.6024 3.88439 10.785C3.92008 10.8771 3.9736 10.9612 4.04189 11.0325L6.29189 13.2825C6.36161 13.3528 6.44456 13.4086 6.53595 13.4467C6.62735 13.4847 6.72538 13.5043 6.82439 13.5043C6.92339 13.5043 7.02142 13.4847 7.11282 13.4467C7.20421 13.4086 7.28716 13.3528 7.35689 13.2825C7.42718 13.2128 7.48298 13.1298 7.52105 13.0384C7.55913 12.947 7.57873 12.849 7.57873 12.75C7.57873 12.651 7.55913 12.553 7.52105 12.4616C7.48298 12.3702 7.42718 12.2872 7.35689 12.2175L6.38188 11.25H13.5744C14.1711 11.25 14.7434 11.0129 15.1654 10.591C15.5873 10.169 15.8244 9.59674 15.8244 9V6C15.8244 5.80109 15.7454 5.61032 15.6047 5.46967C15.4641 5.32902 15.2733 5.25 15.0744 5.25Z" fill="#FCFCFC"/>
                              </svg>
                              <span class="mr-1">{{ $t('submit') }}</span>
                              </v-btn>
                              <v-btn
                                v-if="id"
                                color="primary"
                                :height="isMobile || isTablet ? auto : 55"
                                :width="isMobile || isTablet ? auto : 138"
                                :loading="isLoading"
                                @click="update"
                              >
                                {{ $t('submit-edit') }}
                              </v-btn>
                              <v-btn
                                color="secondary"
                                outlined
                                :height="isMobile || isTablet ? auto : 55"
                                :width="isMobile || isTablet ? auto : 138"
                                disabled
                              >
                              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14 13.6875H14.8438C15.2164 13.6864 15.5734 13.5379 15.8369 13.2744C16.1004 13.0109 16.2489 12.6539 16.25 12.2812V6.65625C16.2489 6.28363 16.1004 5.92659 15.8369 5.66311C15.5734 5.39963 15.2164 5.25111 14.8438 5.25H4.15625C3.78363 5.25111 3.42659 5.39963 3.16311 5.66311C2.89963 5.92659 2.75111 6.28363 2.75 6.65625V12.2812C2.75111 12.6539 2.89963 13.0109 3.16311 13.2744C3.42659 13.5379 3.78363 13.6864 4.15625 13.6875H5" stroke="#999999" stroke-width="1.2" stroke-linejoin="round"/>
                              <path d="M13.145 9.1875H5.855C5.3828 9.1875 5 9.5703 5 10.0425V15.645C5 16.1172 5.3828 16.5 5.855 16.5H13.145C13.6172 16.5 14 16.1172 14 15.645V10.0425C14 9.5703 13.6172 9.1875 13.145 9.1875Z" stroke="#999999" stroke-width="1.2" stroke-linejoin="round"/>
                              <path d="M14 5.25V4.40625C13.9989 4.03363 13.8504 3.67659 13.5869 3.41311C13.3234 3.14963 12.9664 3.00111 12.5938 3H6.40625C6.03363 3.00111 5.67659 3.14963 5.41311 3.41311C5.14963 3.67659 5.00111 4.03363 5 4.40625V5.25" stroke="#999999" stroke-width="1.2" stroke-linejoin="round"/>
                              <path d="M14.2812 8.0625C14.7472 8.0625 15.125 7.68474 15.125 7.21875C15.125 6.75276 14.7472 6.375 14.2812 6.375C13.8153 6.375 13.4375 6.75276 13.4375 7.21875C13.4375 7.68474 13.8153 8.0625 14.2812 8.0625Z" fill="#999999"/>
                              </svg>
                              <span class="mr-1">{{ $t('invoicePrint') }}</span>
                              </v-btn>
                              <v-btn
                                color="secondary"
                                outlined
                                :height="isMobile || isTablet ? auto : 55"
                                :width="isMobile || isTablet ? auto : 138"
                                disabled
                              >
                              <span>{{ $t('submit&print') }}</span>
                              </v-btn>
                            </v-container>
                          </div>
                          <div>
                            <v-card-text class="pa-0 text-body-2 mb-1">{{ $t('discount') }}</v-card-text>
                            <v-container
                              class="pa-0 ma-0 discount"
                              :class="{'d-flex' : percentDiscountStatus}"
                              style="width: 200px;"
                            >
                              <money
                                v-model="discount"
                                :dense="true"
                                :outlined="true"
                                :solo="false"
                                :clearable="true"
                                value-when-is-empty="0"
                                :options="options"
                                class="mb-3 dense"
                                :append-icon="(!percentDiscountStatus ? 'mdi-percent-outline' : null)"
                                :disabled="(sum > 0 ? (percentDiscountStatus ? true : false) : true)"
                                @append="discountChangeStatus"
                                @input="checkTotalDiscount"
                              />
                              <v-text-field
                                v-if="percentDiscountStatus"
                                v-model="discountPercent"
                                append-icon="mdi-currency-usd"
                                placeholder="%"
                                class="ms-1"
                                height="20"
                                outlined
                                dense
                                type="number"
                                max="100"
                                min="0"
                                @keyup="discountCheck"
                                @blur="discountCheck"
                                @click:append="discountChangeStatus"
                              />
                            </v-container>
                            <v-card-text class="pa-0 text-body-2 mt-5">{{ $t('tax') }}</v-card-text>
                            <v-container
                              class="wrapper-toggle-tax mt-1 d-flex align-center pa-0"
                            >
                              <div
                                v-for="(item, index) in taxOption"
                                :key="index"
                                @click="selectTaxOption(item)"
                                class="child flex-fill text-center"
                                :style="{
                                'background-color': selectedTaxOption == item.value ? '#0066ff' : '',
                                'border-color': selectedTaxOption == item.value ? '#0066ff' : 'silver',
                                'color': selectedTaxOption == item.value ? '#fff' : ''
                                }"
                              >
                                <v-card-text class="pa-0 text-body-2">{{ item.label }}</v-card-text>
                              </div>
                            </v-container>
                            <!-- <div class="d-flex justify-space-between align-center mt-5">
                              <v-card-text class="pa-0 text-body-2">{{ $t('tax') }}</v-card-text>
                              <v-checkbox
                                v-model="taxStatus"
                                class="mt-0 mb-0 mx-1"
                                value="active"
                                hide-details
                              />
                            </div>
                            <v-text-field
                              v-if="taxStatus"
                              v-model="taxPercent"
                              append-icon="mdi-percent-outline"
                              outlined

                              v-model="totalTax"
                              readonly
                            />
                              dense
                              style="width: 200px;"
                              :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                              hide-details
                              type="number"
                              clearable
                              readonly
                            /> -->
                          </div>
                          <div class="flex-fill">
                            <div class="header-total d-flex justify-space-between">
                              <v-card-text class="pa-0 text-body-1" style="color: #0066ff;">{{ $t('sum-total') }}</v-card-text>
                              <v-card-text class="pa-0 text-body-1" style="color: #0066ff;">{{ $numberFormat(total) }} {{ currency.symbol }}</v-card-text>
                            </div>
                            <div class="body-total d-flex align-center">
                              <v-container class="pa-2" style="border-left: 1px solid silver;">
                                <div class="d-flex justify-space-between align-center">
                                  <v-card-text class="pa-0 text-body-2">{{ $t('total-invoice') }}</v-card-text>
                                  <v-card-text class="pa-0 text-body-2">{{ $numberFormat(+total - +totalTax + +discount) }} {{ currency.symbol }}</v-card-text>
                                </div>
                                <div class="d-flex justify-space-between align-center my-3">
                                  <v-card-text class="pa-0 text-body-2">{{ $t('total-tax') }}</v-card-text>
                                  <v-card-text class="pa-0 text-body-2">{{ $numberFormat(totalTax) }} {{ currency.symbol }}</v-card-text>
                                </div>
                                <div class="d-flex justify-space-between align-center">
                                  <v-card-text class="pa-0 text-body-2">{{ $t('total-discount') }}</v-card-text>
                                  <v-card-text class="pa-0 text-body-2">{{ $numberFormat(discount) }} {{ currency.symbol }}</v-card-text>
                                </div>
                              </v-container>
                              <v-container class="pa-2">
                                <div class="d-flex justify-space-between align-center">
                                  <v-card-text class="pa-0 text-body-2">{{ $t('count-of-ware') }}</v-card-text>
                                  <!-- <v-card-text class="pa-0 text-body-2">{{ $numberFormat(totalCount) }}</v-card-text> -->
                                  <v-card-text class="pa-0 text-body-2">{{ items.length }}</v-card-text>
                                </div>
                                <div class="d-flex justify-space-between align-center my-3">
                                  <v-card-text class="pa-0 text-body-2">{{ $t('total-payments') }}</v-card-text>
                                  <v-card-text class="pa-0 text-body-2">{{ totalPayment ? totalPayment.toLocaleString('fa-IR') : 0 }} {{ currency.symbol }}</v-card-text>
                                </div>
                                <div class="d-flex justify-space-between align-center">
                                  <v-card-text class="pa-0 text-body-2">{{ $t('remain') }}</v-card-text>
                                  <v-card-text class="pa-0 text-body-2">{{ $numberFormat(remainInvoice) }} {{ currency.symbol }}</v-card-text>
                                </div>
                              </v-container>
                            </div>
                          </div>
                        </v-container>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
                <v-divider class="mx-0" />
                <v-row class="mx-0">
                  <v-col
                    v-if="$vuetify.breakpoint.mobile"
                    class="pb-0 pt-2"
                    cols="12"
                  >
                    <money
                      v-model="discount"
                      :dense="true"
                      :label="$t('discount')"
                      :outlined="true"
                      :solo="false"
                      :clearable="true"
                      value-when-is-empty=""
                      :options="options"
                      class="dense mt-3"
                      :percent="true"
                      :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : (sum > 0 ? false : true))"
                      @changePercent="changePercent"
                      @input="checkTotalDiscount"
                    />
                  </v-col>
                  <v-col
                    v-if="$vuetify.breakpoint.mobile"
                    class="pb-0 pt-2 mt-3"
                    cols="12"
                  >
                    {{ $t('sum') }} {{ $t('tax') }} : {{ $numberFormat(totalTax) }}
                  </v-col>
                  <v-col
                    v-if="$vuetify.breakpoint.mobile"
                    class="pb-0 pt-2"
                    cols="12"
                  >
                    {{ $t('sum') }} : {{ $numberFormat(total) }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mx-2 mt-5" />
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container
            class="px-1"
            fluid
          >
            <v-row class="mx-0 my-2 mb-4">
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                md="2"
                sm="2"
                class="mb-0 px-1 py-1"
              >
                <v-select
                  v-model="type"
                  :label="$t('documentType')"
                  :items="typeItems"
                  :disabled="(this.$route.name === 'presaleEdit' || itemsProp ? false : true)"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                  item-disabled="disable"
                  @input="checkProductsCount"
                />
              </v-col>
              <v-col
                cols="12"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                md="2"
                sm="2"
                class="mb-0 px-1 py-1"
              >
                <autocomplete
                  v-model="given"
                  :title="$t('accountGiven')"
                  type="given"
                />
              </v-col>
            </v-row>
            <v-row class="mx-0 my-2">
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                class="py-1 px-1"
                cols="12"
                md="2"
                sm="2"
                style="height: 20px"
                :class="{'mb-5' : $vuetify.breakpoint.mobile}"
              >
                <status
                  v-model="status"
                  :hideconfig="true"
                  :type="type"
                  :value="status"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                md="2"
                class="py-1 px-1"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
              >
                <tag
                  v-model="tag"
                  :solo="false"
                  :input="tag"
                  :height="25"
                />
              </v-col>
              <v-col
                v-show="showCurrency && (bodyStatus == false || !$vuetify.breakpoint.mobile)"
                cols="12"
                sm="2"
                md="2"
                class="py-1 px-1"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
              >
                <autocomplete
                  ref="refCurrency"
                  v-model="currency"
                  :rules="[v => !!v || $t('is-required')]"
                  :title="$t('currency')"
                  type="currency"
                  :init="defaultCurrency"
                  :value="currency"
                  @change="changeCurrency"
                />
              </v-col>
              <v-col
                v-show="showCurrency && (bodyStatus == false || !$vuetify.breakpoint.mobile)"
                cols="12"
                sm="2"
                md="2"
                :class="{'mb-0' : $vuetify.breakpoint.mobile}"
                class="py-1 px-1"
              >
                <money
                  v-model="currency_amount"
                  :label="$t('currency-rate')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                class="py-1 px-1"
                md="2"
                sm="2"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
              >
                <template>
                  <v-text-field
                    id="dueDateId"
                    v-model="dueDate"
                    :label="$t('dueDate')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                    @keyup="dueDate = null"
                  />
                  <date-picker
                    v-model="dueDate"
                    element="dueDateId"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="date"
                    :max="$store.state.endDate"
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                v-if="type === 'returnSell'"
                cols="12"
                sm="2"
                md="2"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                class="py-1 px-1"
              >
                <aicomplete
                  v-model="refInvoice"
                  title="refSellInvoice"
                  type="invoices"
                  :val="refInvoice"
                  :cache-items="true"
                  :data="JSON.stringify({type: ['sell'], 'account': (account ? account.id : null)})"
                />
              </v-col>
              <v-col
                v-show="(type === 'sell' || type === 'presale') && (bodyStatus == false || !$vuetify.breakpoint.mobile)"
                cols="12"
                :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                md="2"
                sm="2"
                class="mb-0 px-1 py-1"
              >
                <v-select
                  v-model="priceType"
                  :label="$t('priceTypeCalculate')"
                  :items="priceTypeItems"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                  item-disabled="disable"
                />
              </v-col>
            </v-row>
            <v-row class="mx-0 my-2">
              <v-col
                cols="12"
                class="py-0"
              >
                <notification
                  v-model="notifications"
                  :value="notifications"
                />
              </v-col>
            </v-row>
            <v-row v-if="!isMobile && customFieldsPermission" class="mx-0 my-2">
              <custom-fields
                v-model="customFields"
                :value="customFields"
                type-prop="invoiceCustomFields"
                class="px-4"
              />
            </v-row>
            <v-row />
            <!--<v-expansion-panels
              v-model="panel"
              class="pt-3 px-1"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t('otherInputs') }}
                  ✏️
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>-->
          </v-container>
        </v-tab-item>
        <v-tab-item v-if="$store.state.allConfig && $store.state.allConfig.commissionSystem == 'active'">
          <v-row
            v-show="type == 'sell' || type == 'returnSell'"
            class="mx-0 my-2"
          >
            <v-col
              class="px-1 xs py-1"
              cols="12"
              :class="{'mb-3' : $vuetify.breakpoint.mobile}"
              md="2"
            >
              <autocomplete
                v-model="seller"
                title="visitor"
                type="person"
                :new-btn="true"
                :data="JSON.stringify({type: 'visitor'})"
                :value="seller"
              />
            </v-col>
            <v-col
              class="px-1 xs py-1 d-flex"
              cols="12"
              :class="{'mb-3' : $vuetify.breakpoint.mobile}"
              md="2"
            >
              <money
                v-model="commissionAmount"
                :dense="true"
                :outlined="true"
                style="width: 100%"
                :solo="false"
                :clearable="true"
                :label="$t('commissionAmount')"
                value-when-is-empty=""
                :options="options"
                :disabled="(total > 0 ? false : true)"
                class="mb-3 dense"
                @input="calcCommissionPercent"
              />
            </v-col>
            <v-col
              class="px-1 xs py-1 d-flex"
              cols="12"
              :class="{'mb-3' : $vuetify.breakpoint.mobile}"
              md="2"
            >
              <v-text-field
                v-model="commissionPercent"
                v-disabled-icon-focus
                height="20"
                :label="$t('commissionPercent')"
                dense
                outlined
                suffix="%"
                :disabled="(total > 0 ? false : true)"
                class="mb-2 dense ms-1"
                type="number"
                @focus="focusEvent"
                @input="calcCommissionAmount"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="invoice"
                :val="(id && attachments ? attachments : null)"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row
            class="mb-3 mx-0"
          >
            <investors
              v-model="investors"
              :value="investors"
            />
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions class="pt-0 px-3 pb-0">
        <v-row class="ma-0">
          <v-col
            v-if="!id"
            cols="6"
            class="px-0"
          >
            <v-btn
              v-if="bodyStatus == false && $vuetify.breakpoint.mobile"
              color="primary"
              class="mr-0"
              @click="bodyStatus = true"
            >
              {{ $t('continuance') }}
            </v-btn>
          </v-col>
          <v-col
            v-if="id"
            cols="6"
            class="px-0"
          >
            <v-btn
              v-if="bodyStatus == false && $vuetify.breakpoint.mobile"
              color="primary"
              class="mr-0"
              @click="bodyStatus = true"
            >
              {{ $t('continuance') }}
            </v-btn>
            <!--<v-btn
              v-if="id && bodyStatus || !$vuetify.breakpoint.mobile"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>-->
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              v-if="isMobile && bodyStatus == true"
              color="grey"
              outlined
              class="float-left"
              @click="bodyStatus = false"
            >
              {{ $t('back') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-dialog
      v-model="goldDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="goldDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <div v-if="itemDialog">
          <v-row
            class="ma-0"
          >
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="itemDialog.count"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('count') + ' / ' + $t('weight')"
                hide-details
                flat
                class="mb-3 dense"
                :rules="[v => !!v || $t('is-required')]"
                :suffix="(itemDialog.unit ? itemDialog.unit.fame : '')"
                :placeholder="$t('count')"
                type="number"
                @blur="zeroCountCheck(itemDialog)"
                @input="checkCount(itemDialog)"
                @focus="focusEvent"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <money
                v-model="itemDialog.fee"
                :dense="true"
                :outlined="true"
                :rules="[feeValidate]"
                :solo="false"
                :label="$t('feePerUnit')"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="itemDialog.cutie"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('cutie')"
                hide-details
                flat
                class="mb-3 dense"
                :rules="[v => !!v || $t('is-required')]"
                type="number"
                @input="calcSum"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="itemDialog.construction_wages_percent"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('construction_wages_percent')"
                hide-details
                flat
                class="mb-3 dense"
                type="number"
                @input="calConstructionWages"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <money
                v-model="itemDialog.construction_wages"
                :dense="true"
                :outlined="true"
                :label="$t('construction_wages')"
                :rules="[feeValidate]"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :disabled="true"
                :options="options"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="itemDialog.profit_percent"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('profit_percent')"
                hide-details
                flat
                class="mb-3 dense"
                type="number"
                @input="calProfit"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <money
                ref="refProfit"
                v-model="itemDialog.profit"
                :dense="true"
                :outlined="true"
                :rules="[feeValidate]"
                :solo="false"
                :disabled="true"
                :clearable="true"
                value-when-is-empty=""
                :label="$t('profit_percent')"
                :options="options"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="itemDialog.commission_percent"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('commission_percent')"
                hide-details
                flat
                class="mb-3 dense"
                type="number"
                @input="calCommission"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <money
                v-model="itemDialog.commission"
                :dense="true"
                :outlined="true"
                :rules="[feeValidate]"
                :solo="false"
                :disabled="true"
                :label="$t('goldCommission')"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <div class="d-flex">
                <money
                  v-model="itemDialog.discount"
                  :dense="true"
                  :label="$t('discount')"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                  :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : (itemDialog.fee*itemDialog.count > 0 ? false : true))"
                  @input="checkDiscount(itemDialog)"
                />
                <v-text-field
                  v-model="itemDialog.discountPercent"
                  v-disabled-icon-focus
                  height="20"
                  dense
                  flat
                  outlined
                  solo
                  suffix="%"
                  class="mb-2 dense ms-1"
                  style="max-width: 80px"
                  type="number"
                  :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                  @focus="focusEvent"
                  @input="checkDiscountPercent(itemDialog)"
                />
              </div>
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="ma-0">
            <v-col
              cols="12"
              md="4"
            >
              {{ $t('cutiePer750') }} : {{ (itemDialog.cutie / 750).toFixed(2) }}
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              {{ $t('rawAmount') }} : {{ $numberFormat(((itemDialog.count * itemDialog.fee)*(itemDialog.cutie / 750).toFixed(2)).toFixed($store.state.currency.decimal)) }}
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              {{ $t('sumOtherItems') }} : {{ $numberFormat((+(itemDialog.construction_wages ?? 0) + +(itemDialog.profit ?? 0) + +(itemDialog.commission ?? 0))) }}
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              {{ $t('tax') }} : ({{ itemDialog.product.tax_percent }} %) {{ $numberFormat(((+(itemDialog.construction_wages ?? 0) + +(itemDialog.profit ?? 0) + +(itemDialog.commission ?? 0))*(itemDialog.product.tax_percent/100)).toFixed($store.state.currency.decimal)) }}
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              {{ $t('sum') }} : {{ $numberFormat(((+(itemDialog.construction_wages ?? 0) + +(itemDialog.profit ?? 0) + +(itemDialog.commission ?? 0))*(itemDialog.product.tax_percent/100)) + +(itemDialog.construction_wages ?? 0) + +(itemDialog.profit ?? 0) + +(itemDialog.commission ?? 0) + (itemDialog.count * itemDialog.fee)*(itemDialog.cutie / 750).toFixed(2) - +(itemDialog.discount ?? 0) ) }}
            </v-col>
          </v-row>
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="pink darken-1"
            text
            @click="goldDialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="80%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="paymentDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('newPayment') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <payments :account="account" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            class="pb-2 px-2"
            cols="12"
          >
            <print
              :data-prop="reportData"
              :report-prop="reportName"
              :resource-prop="reportName"
            />
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPriceChange"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Use Google's location service?
        </v-card-title>

        <v-card-text>
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="dialogPriceChange = false"
          >
            {{ $t('yes') }}
          </v-btn>

          <v-btn
            color="pink darken-1"
            text
            @click="dialogPriceChange = false"
          >
            {{ $t('no') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  import Description from '../../components/general/description/Description'
  import print from './../../components/general/printViewer/printViewer'
  import filePicker from '../../components/general/filePicker/index'
  import investors from './partial/investors.vue'
  import customFields from '../../components/general/customFields/index.vue'
  import payments from './partial/payments.vue'
  import Composite from './partial/Composite.vue'
  export default {
    name: 'InvoiceIndex',
    components: {
      Products: () => import('../../components/general/Products/Products'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      customFields,
      Description,
      investors,
      filePicker,
      print,
      payments,
      autocomplete,
      Task,
      Composite,
    },
    mixins: [General],
    props: ['input', 'formType', 'refId', 'accountProp', 'itemsProp'],
    data: () => ({
      priceType: 'fixedPrice',
      priceTypeItems: [],
      pattern: 1,
      goldTotal: 0,
      invoicePattern: 1,
      invoiceTypeItems: null,
      paymentDialog: null,
      itemDialog: null,
      selected: [],
      goldDialog: false,
      checkDiscountEdit: false,
      render: true,
      validBank: true,
      contractNumber: null,
      notifications: null,
      customFields: null,
      refInvoice: null,
      investors: null,
      attachments: null,
      commissionAmount: null,
      commissionPercent: null,
      given: null,
      officialNumber: null,
      tableHeightInvoice: 380,
      showCurrency: true,
      reportData: null,
      reportName: null,
      seller: null,
      plan: null,
      percentDiscountStatus: false,
      bodyStatus: false,
      dialogPriceChange: false,
      allowPriceChange: false,
      printDialog: false,
      discountEdit: 0,
      checkNumber: false,
      checkOfficialNumber: false,
      deletDialog: false,
      showClearing: true,
      showSelect: false,
      showProductList: false,
      clearingStatus: false,
      filter: false,
      valid: true,
      number: null,
      bank: null,
      entrepot: null,
      payments: null,
      checks: null,
      account: null,
      dueDate: null,
      date: null,
      currency_amount: null,
      content: null,
      model: null,
      printType: 'normal',
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      currency: null,
      temp: null,
      taxPercent: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      typeItems: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      type: 'sell',
      taskId: null,
      patternItems: [],
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      search: null,
      discountPercent: false,
      taxStatus: false,
      totalCount: 0,
      discount: 0,
      totalDiscount: 0,
      totalTax: 0,
      totalFee: 0,
      sumRow: 0,
      sum: 0,
      decimal: 0,
      totalDiscountType: false,
      watcher: false,
      compositeTableData: null,
      optionDialogType: null,
      totalPayment: null,
      remainInvoice: null,
      userInfo: null,
      isInvoiceCreated: false,
      editCompositeTableData : null,
      selectedTaxOption: null
/*       pageCount: 1,
      page: 1 */
    }),
    computed: {
      total: function () {
        var sum = parseFloat(this.sum) - parseFloat((this.totalDiscount !== '' ? this.totalDiscount : 0))
        this.checkBankRemain(sum)
        return sum.toFixed(this.decimal)
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (s.value === 'expire_date') {
            if (app.type !== 'purchase') return false
          }
          return app.headers.includes(s)
        })
      },
      compositeType () {
        if (this.$route.path == "/sell/index" || this.$route.path.includes("/sell/edit") || this.$route.path == "/presale/index" || this.$route.path.includes("/presale/edit") || this.$route.path == "/returnPurchase/index" || this.$route.path.includes("/returnPurchase/edit")) {
          return "recieve"
        }
        if (this.$route.path == "/purchase/new" || this.$route.path.includes("/purchase/edit") || this.$route.path == "/returnSell/index" || this.$route.path.includes("/returnSell/edit")) {
          return "pay"
        } else {
          return null
        }
      },
      taxOption () {
        return [
          { label: this.$t('active'), value: 'active' },
          { label: this.$t('deactive'), value: 'deactive' }
        ]
      }
    },
    watch: {
      investor (val) {
      },
      showProductList (val, oldVal) {
        if (val) {
          localStorage.setItem('showProductListInvoice', val)
        } else {
          localStorage.removeItem('showProductListInvoice')
        }
      },
      account (val) {
        if (val) {
          this.getPersonInfo(val.id)
        }
        // this.clearRows()
      },
      currency (val, old) {
        this.decimal = 0
        if (val) {
          this.decimal = val.decimal
          if (this.render) {
            this.currency_amount = val.amount
            this.bank = null
          }
        } else {
          this.currency = this.$store.state.currency
          this.currency_amount = null
        }
        if (this.render) {
          // this.clearRows()
        }
      },
      taxStatus (val, old) {
        if (val) {
          this.totalDiscountType = false
          this.totalDiscount = 0
          this.discount = 0
        }
        this.calcSum()
      },
      taxPercent (val, old) {
        if (this.taxStatus) {
          this.totalDiscountType = false
          this.totalDiscount = 0
          this.discount = 0
        }
        this.calcSum()
      },
      defaultCurrency () {
        if (this.defaultCurrency && !this.id) {
          this.$refs.refCurrency.setModel(this.defaultCurrency)
          this.currency_amount = this.defaultCurrency.amount
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      payments: {
        handler () {
          var app = this
          app.showClearing = true
          if (app.payments && app.payments.length > 0) {
            app.payments.map(function (value, key) {
              if (value.chip) {
                app.showClearing = false
                app.clearingStatus = false
                app.bank = null
              }
            })
          }
          // app.checks.map(function (value, key) {
          //   if (value.chip) {
          //     app.showClearing = false
          //     app.clearingStatus = false
          //     app.bank = null
          //   }
          // })
        },
        deep: true,
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      itemsProp: {
        handler(val) {
          if (val) {
            this.items = val
            this.$nextTick(() => {
              this.calcSum()
            });
          } else {
            this.items = []
            this.addRow()
          }
        },
        immediate: true,
        deep: true
      },
      goldDialog (val) {
        if (!val) {
          this.calcSum()
        }
      },
      totalTax(val) {
        this.checkTaxStatus()
      }
    },
    activated: function () {
      this.beforeMount()
    },
    beforeMount () {
      this.invoiceTypeItems = [
        {
          value: 1,
          text: this.$t('firstType'),
        },
        {
          value: 2,
          text: this.$t('secondType'),
        },
        {
          value: 3,
          text: this.$t('thirdType'),
        },
      ]
      this.patternItems = [
        {
          value: '1',
          text: this.$t('pattern1'),
        },
        {
          value: '2',
          text: this.$t('pattern2'),
        },
        {
          value: '3',
          text: this.$t('pattern3'),
        },
        {
          value: '4',
          text: this.$t('pattern4'),
        },
        {
          value: '5',
          text: this.$t('pattern5'),
        },
        {
          value: '6',
          text: this.$t('pattern6'),
        },
        {
          value: '7',
          text: this.$t('pattern7'),
        },
      ]
      // this.beforeMount()
    },
    mounted () {
      if (localStorage.getItem('showProductListInvoice')) {
        this.showProductList = true
      }
      this.taxPercent = this.$store.state.tax
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 40,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 40,
        },
        {
          text: this.$t('product') + '/' + this.$t('service'),
          sortable: false,
          value: 'product',
          width: 300,
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit',
          width: 140,
        },
        {
          text: this.$t('count') + ' / ' + this.$t('weight'),
          sortable: false,
          value: 'count',
          width: 200,
        },
        {
          text: this.$t('fee'),
          sortable: false,
          value: 'fee',
          width: 180,
        },
        {
          text: this.$t('discount'),
          sortable: false,
          value: 'discount',
          width: 230,
        },
        {
          text: this.$t('tax'),
          sortable: false,
          value: 'tax',
          width: 220,
        },
        {
          text: this.$t('sum'),
          sortable: false,
          value: 'sum',
          width: 170,
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'content',
          width: 300,
        },
        {
          text: this.$t('entrepot'),
          sortable: false,
          value: 'entrepot',
          width: 300,
        },
        {
          text: this.$t('expireDate'),
          sortable: false,
          value: 'expire_date',
          width: 300,
        },
      ]
      var presaleDisable = false
      if (this.$route.name === 'presaleEdit' && this.id) {
        presaleDisable = true
      }
      this.typeItems = [
        {
          value: 'sell',
          text: this.$t('sell'),
        },
        {
          value: 'presale',
          text: this.$t('presale'),
        },
        {
          value: 'returnSell',
          text: this.$t('returnSell'),
          disable: presaleDisable,
        },
        {
          value: 'purchase',
          text: this.$t('purchase'),
          disable: presaleDisable,
        },
        {
          value: 'returnPurchase',
          text: this.$t('returnPurchase'),
          disable: presaleDisable,
        },
      ]
      this.priceTypeItems = [
        {
          value: 'fixedPrice',
          text: this.$t('fixedPrice'),
        },
        {
          value: 'formulaPrice',
          text: this.$t('formulaPrice'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
      if (this.$route.params.id === null || this.$route.params.id === undefined) {
        // this.addRow()
        // this.currency = this.$store.state.currency
        // this.currency_amount = this.$store.state.currency.amount
      }
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
      })
      this.composite = this.$refs.composite
      this.userInfo = JSON.parse(localStorage.getItem('token'))
      this.$nextTick(() => {
        this.checkTaxStatus()
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      openGoldDialog (item) {
        this.itemDialog = item
        this.taxStatus = 'active'
        this.goldDialog = true
      },
      calGoldDialog () {
        if (this.itemDialog) {
          this.calConstructionWages()
          this.calProfit()
          this.calCommission()
        }
      },
      calConstructionWages () {
        if (this.itemDialog.construction_wages_percent === undefined) {
          this.itemDialog.construction_wages_percent = 0
        }
        var cutie = (this.itemDialog.cutie && this.itemDialog.cutie > 0 ? this.itemDialog.cutie : 750) / 750
        var value = Math.trunc((cutie.toFixed(2) * this.itemDialog.count * this.itemDialog.fee) - +this.itemDialog.discount)
        this.itemDialog.construction_wages = Math.trunc(value * (this.itemDialog.construction_wages_percent / 100))
      },
      calProfit () {
        if (this.itemDialog.profit_percent === undefined) {
          this.itemDialog.profit_percent = 0
        }
        var cutie = (this.itemDialog.cutie && this.itemDialog.cutie > 0 ? this.itemDialog.cutie : 750) / 750
        var value = Math.trunc((cutie.toFixed(2) * this.itemDialog.count * this.itemDialog.fee) - +this.itemDialog.discount + +this.itemDialog.construction_wages)
        this.itemDialog.profit = Math.trunc(value * (this.itemDialog.profit_percent / 100))
      },
      calCommission () {
        if (this.itemDialog.commission_percent === undefined) {
          this.itemDialog.commission_percent = 0
        }
        var cutie = (this.itemDialog.cutie && this.itemDialog.cutie > 0 ? this.itemDialog.cutie : 750) / 750
        var value = Math.trunc((cutie.toFixed(2) * this.itemDialog.count * this.itemDialog.fee) - +this.itemDialog.discount)
        this.itemDialog.commission = Math.trunc(value * (this.itemDialog.commission_percent / 100))
      },
      changeEntrepotAtRow (item, index) {
        if (!this.watcher) {
          return false
        }
        if (!item.product || !item.article_entrepot) {
          return false
        }
        var app = this
        app.isLoading = true
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'getProductStock',
            id: item.product.id,
            entrepotId: item.article_entrepot.id,
          },
        })
          .then(res => {
            res = res.data
            if (item.product.stock.count > res) {
              item.count = 0
              app.snakbarText = app.$t('alert-is-not-enough-inventory')
              app.snakbarColor = 'pink'
              app.snakbar = true
            }
            item.product.stock.count = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      unitCalc (item) {
        if (item.product && item.unit) {
          var i = item.product.units.findIndex(x => x.unit_id === item.unit.id)
          if (i !== -1 && item.product.units[i].value) {
            return +item.product.units[i].value
          } else {
            return 1
          }
        }
      },
      unitItems (item) {
        if (item.product) {
          var units = [item.product.unit]
          if (item.product.units && item.product.units.length > 0) {
            item.product.units.map(function (value, index) {
              value.unit.value = value.value
              units.push(value.unit)
            })
          }
          if (!item.unit) {
            item.unit = item.product.unit
          }
          return units
        } else {
          return []
        }
      },
      onResize () {
        var height = 550
        if (window.innerHeight < 650) {
          height = 430
        }
        this.tableHeightInvoice = (this.isMobile ? window.innerHeight - height : window.innerHeight - height)
      },
      beforeMount () {
        if (this.accountProp) {
          this.account = this.accountProp
        }
        if (this.$route.name === 'Sell') {
          this.type = 'sell'
        }
        if (this.$route.name === 'presale') {
          this.type = 'presale'
        }
        if (this.$route.name === 'purchase') {
          this.type = 'purchase'
          this.number = 1
        }
        if (this.$route.name === 'returnPurchase') {
          this.type = 'returnPurchase'
          this.number = 1
        }
        if (this.$route.name === 'returnSell') {
          this.type = 'returnSell'
        }
        if (this.$route.params.id != null) {
          this.show()
          this.id = this.$route.params.id
          this.render = false
        } else {
          this.defaultCurrency = this.getDefault('defaultCurrency')
          this.currency = this.$store.state.currency
          this.getInvoiceNumber()
          if (this.items && this.items.length === 0) {
            this.addRow()
            this.watcher = true
          }
        }
        if (this.$store.state.currency && !this.id && !this.account) {
          this.currency = this.$store.state.currency
          this.currency_amount = this.$store.state.currency.amount
        }
        if (this.itemsProp) {
          this.items = this.itemsProp
        } else {
          if (!this.account && !this.id) {
            this.items = []
            this.watcher = true
            this.addRow()
          }
        }
      },
      checkProductsCount () {
        var app = this
        if (this.items && this.items.length > 0) {
          this.items.map(function (value, index) {
            // value.product = null
            if (app.$refs['refProduct' + index] !== undefined) {
              // app.$refs['refProduct' + index].clear()
            }
          })
        }
      },
      zeroCountCheck (item) {
        if (parseFloat(item.count) === 0) {
          item.count = 1
          this.checkCount(item)
        }
      },
      discountChangeStatus () {
        this.percentDiscountStatus = !this.percentDiscountStatus
        this.taxStatus = false
      },
      discountCheck () {
        this.discount = 0
        this.totalDiscount = 0
        if (Number(this.discountPercent) > 100) {
          this.discountPercent = 100
        }
        if (Number(this.discountPercent) < 0) {
          this.discountPercent = 0
        }
        if (this.total > 0) {
          var discount = this.total * (this.discountPercent / 100)
          this.discount = discount.toFixed(this.decimal)
          this.checkTotalDiscount()
        }
      },
      checkBankRemain (sum) {
        var app = this
        app.validBank = true
        if (app.type === 'purchase' || app.type === 'returnSell') {
          if (this.clearingStatus && this.bank && sum > parseFloat(this.bank.remain.currency_remain)) {
            app.validBank = true
            app.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
            app.snakbarColor = 'pink'
            app.snakbar = true
          }
        }
      },
      getInvoiceNumber () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              select: 'getInvoiceNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
              }
              if (res.status === 'success') {
                app.number = res.number
              }
              app.checkNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      getOfficialInvoiceNumber () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.officialNumber,
              select: 'getOfficialInvoiceNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkOfficialNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.officialNumber = res.number
              }
              app.checkOfficialNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      changeProduct (item, i) {
        var count = 0
        var app = this
        this.items.map(function (value, index) {
          if (value.product && value.product.id === item.product.id) {
            count++
          }
          if (count > 1) {
            app.snakbarText = app.$t('thisProductIsRepetitious')
            app.snakbarColor = 'pink'
            app.snakbar = true
            // app.remove(item, i)
            return false
          }
        })
        if (item.product && item.product.kind_id === 112) {
          item.construction_wages_percent = item.product.construction_wages_percent
          item.profit_percent = item.product.profit_percent
          item.commission_percent = item.product.commission_percent
          item.count = (app.watcher ? item.product.weight : item.count)
        }
        if (this.type === 'sell' || this.type === 'returnPurchase' || this.type === 'presale') {
          if (!this.deleteItem && this.currency && item.product && item.product.price && this.currency.id === this.$store.state.currency.id) {
            item.fee = item.product.price
          } else {
            if (!this.id && !this.itemsProp) {
              // item.fee = 0
            }
          }
          if (this.currency && item.product && item.product.discount && this.currency.id === this.$store.state.currency.id) {
            item.discount = item.product.discount
            item.discountPercent = this.itemDiscountPercentCalc(item)
          }
          if (this.currency && item.product && item.product.discount === null && item.product.discount_percent && this.currency.id === this.$store.state.currency.id) {
            item.discountPercent = item.product.discount_percent
          }
          // this.calcSum()
        }
        if (!item.product) {
          item.unit = null
        }
      },
      clearRow (item) {
        item.unit = null
        item.fee = 0
        item.count = 0
        item.discount = 0
        item.discountPercent = 0
        item.tax = 0
      },
      clearRows () {
        this.items.map(function (value, index) {
          value.fee = 0
          value.count = 0
          value.discount = 0
          value.discountPercent = 0
          value.tax = 0
        })
      },
      changePercent (val) {
        this.discountPercent = val
        this.percentDiscountStatus = true
      },
      append (product) {
        var count = 1
        var stock = 20000000
        if (product.type === 'product') {
          stock = (product.stock ? product.stock.count : 0)
          if (this.type === 'sell' || this.type === 'returnPurchase') {
            if (!product.stock || product.stock.count <= 0) {
              this.snakbarText = this.$t('alert-is-not-enough-inventory')
              this.snakbarColor = 'pink'
              this.snakbar = true
              return false
            }
            if (product.stock && product.stock.count < 1) {
              count = parseFloat(product.stock.count)
            }
          }
        }
        var index = -1
        // if (this.items && this.items.length == 0) {
        //   this.addRow()
        // }
        if (this.items && this.items.length > 0 && !this.items[0].product) {
          this.items.splice(0, 1)
        }
        index = this.items.findIndex(x => (x.product ? x.product.id === product.id : null))
        if (index !== -1) {
          if (parseFloat(stock) - parseFloat(this.items[index].count) - parseFloat(1) >= 0) {
            this.items[index].count = parseFloat(this.items[index].count) + parseFloat(1)
            if (this.type === 'sell' || this.type === 'presale') {
              if (product && this.priceType === 'formulaPrice') {
                this.getPrice(this.items[index])
              }
              // if (product && !product.price) {
              //   this.getPrice(this.items[index])
              // }
            }
          }
        } else {
          var price = (product.price ? product.price : 0)
          this.addRow(product, count, price)
        }
        var app = this
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.calcSum()
        }, 1000)
      },
      getPrice (item) {
        var app = this
        clearTimeout(this.timer)
        if (!this.showProductList) {
          app.isLoading = true
        }
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: 'getPrice',
              currency_id: app.currency.id,
              type: app.type,
              typePrice: app.typePrice,
              count: item.count,
              customer: app.account,
              product_id: item.product.id,
              category_id: (app.account && app.account.category_id ? app.account.category_id : -1),
            },
          })
            .then(res => {
              res = res.data
              if (res.price > 0) {
                item.fee = res.price
              } else {
                item.fee = 0
              }
              if (item.fee > 0 && item.count > 0) {
                if (res.discount.amount) {
                  item.discount = res.discount.amount
                }
                if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                  var discount = (parseFloat(item.fee) * parseFloat(item.count)) * (parseFloat(res.discount.percent) / 100)
                  item.discount = discount
                }
              }
              app.calcSum()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 500)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      calcSum () {
        this.calGoldDialog()
        var app = this
        app.totalTax = 0
        app.totalDiscount = (this.discountEdit ? this.discountEdit : 0)
        app.totalCount = 0
        app.totalFee = 0
        app.sum = 0
        var sumDiscount = 0
        // if (!this.discountPercent) {
        //   this.discount = 0
        // }
        this.items.map(function (value, index) {
          if (value.discountPercent && value.discountPercent > 0) {
            app.checkDiscountPercentPerRow(value)
          }
          if (parseFloat(value.count) * parseFloat(value.fee) < parseFloat(value.discount)) {
            value.discount = 0
            app.discount = 0
            app.totalDiscount = 0
          }
          if (app.totalDiscountType) {
            value.discount = 0
            value.tax = 0
          } else {
            sumDiscount = sumDiscount + parseFloat(value.discount)
            app.calcTax(value)
          }
          var cutie = 1
          var additionalAmount = 0
          if (value.product && value.product.kind_id === 112) {
            if (value.cutie) {
              cutie = (value.cutie / 750).toFixed(2)
            }
            additionalAmount = +(value.construction_wages ?? 0) + +(value.profit ?? 0) + +(value.commission ?? 0)
          }
          app.totalFee = (parseFloat(value.count) * parseFloat(value.fee) * cutie) + parseFloat(app.totalFee) + +additionalAmount
          app.totalCount = parseFloat(value.count) + parseFloat(app.totalCount)
          app.totalTax = parseFloat(value.tax) + parseFloat(app.totalTax)
          var rowPrice = parseFloat((value.fee * value.count * cutie)) - parseFloat((value.discount === '' || !value.discount ? 0 : value.discount)) + parseFloat(value.tax) + +additionalAmount
          app.sum = parseFloat(rowPrice) + parseFloat(app.sum)
        })
        app.totalFee = app.totalFee.toFixed(this.decimal)
        app.totalTax = app.totalTax.toFixed(this.decimal)
        if (sumDiscount > 0) {
          app.discount = sumDiscount
          // app.totalDiscount = sumDiscount
        }
        this.discountEdit = 0
        // this.calGoldDialog()
      },
      checkTotalDiscount () {
        this.taxStatus = false
        this.totalDiscountType = true
        this.calcSum()
        // if (this.discountPercent) {
        //   if (parseFloat(this.discount) > 100) {
        //     this.discount = 0
        //   }
        //   var discount = parseFloat(this.sum) * (parseFloat(this.discount) / 100)
        //   this.totalDiscount = discount
        // } else {
        this.totalDiscount = this.discount
        // }
        if (this.discountPercent === false && parseFloat(this.discount) > parseFloat(this.sum)) {
          this.discount = 0
          this.totalDiscount = 0
        }
      },
      calcTax (item) {
        if (this.taxStatus === 'active') {
          var taxPercent = this.taxPercent
          if (item.product && item.product.tax_percent !== null) {
            taxPercent = item.product.tax_percent
          }
          var tax = 0
          if (item.product.kind_id === 112) {
            tax = (+(item.construction_wages ?? 0) + +(item.profit ?? 0) + +(item.commission ?? 0)) * taxPercent / 100
          } else {
            tax = (parseFloat(item.fee * item.count) - parseFloat((item.discount === '' || !item.discount ? 0 : item.discount))) * taxPercent / 100
          }
          tax = this.roundMath(tax, this.$store.state.currency.decimal)
          item.tax = tax
        } else {
          item.tax = 0
        }
      },
      changeCurrency () {
        this.bankRemain = 0
        this.currency_amount = this.currency.amount
        this.options = {
          locale: 'en-US',
          prefix: '',
          suffix: this.currency.name,
          precision: 0,
        }
      },
      addRow (product = null, count = 0, price = 0) {
        this.items.push({
          product: product,
          count: count,
          countEdit: 0,
          fee: price,
          construction_wages: 0,
          construction_wages_percent: 0,
          profit: 0,
          tax_percent: 0,
          profit_percent: 0,
          commission: 0,
          commission_percent: 0,
          discount: 0,
          discountPercent: 0,
          tax: 0,
          cutie: 750,
          unit: null,
          content: null,
          article_entrepot: null,
          expire_date: null,
        })
        if (this.type === 'sell' && product && this.priceType === 'formulaPrice') {
          var index = this.items.findIndex(x => x.product.id === product.id)
          this.getPrice(this.items[index])
        }
      },
      remove (item, index) {
        var app = this
        var i = this.items.indexOf(this.deleteItem)
        this.items.splice(i, 1)
        this.calcSum()
        this.deletDialog = false
        setTimeout(function () {
          app.deleteItem = null
        }, 100)
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      checkProduct (item, key) {
        if (item) {
          var index = this.items.findIndex(x => x.product.id === item.id)
          if (index !== key) {
            this.$refs['refProduct' + key].clear()
            this.snakbarText = this.$t('alert-product-is-repetitive')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        }
      },
      calcCommissionAmount () {
        var amount = (parseFloat(this.total) * (this.commissionPercent / 100)).toFixed(this.decimal)
        this.commissionAmount = amount
      },
      calcCommissionPercent (item) {
        var percent = (parseFloat(this.commissionAmount) / parseFloat(this.total)) * 100
        this.commissionPercent = percent
      },
      checkDiscount (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
        }
        item.discountPercent = this.itemDiscountPercentCalc(item)
        this.calcSum()
      },
      checkDiscountPercent (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        item.discount = (parseFloat(item.fee * item.count) * (item.discountPercent / 100)).toFixed(this.decimal)
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
          item.discountPercent = 0
        }
        this.calcSum()
      },
      checkDiscountPercentPerRow (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        item.discount = (parseFloat(item.fee * item.count) * (item.discountPercent / 100)).toFixed(this.decimal)
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
          item.discountPercent = 0
        }
      },
      itemDiscountPercentCalc (item) {
        return (parseFloat(item.discount) / parseFloat(item.fee * (item.count && item.count > 0 ? item.count : 1))) * 100
      },
      checkCount (item) {
        if (this.type === 'sell' || this.type === 'presale' || this.type === 'returnPurchase' || this.type === 'returnSell') {
          var productStock = (item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0)
          if (this.type !== 'returnSell' && item.product && item.product.type === 'product' && this.$store.state.negative_inventory === 'no' && parseFloat(item.count) > productStock + parseFloat((this.$route.name !== 'presaleEdit' ? item.countEdit : 0))) {
            this.snakbarText = this.$t('alert-inventory-is-not-enough')
            this.snakbarColor = 'pink'
            this.snakbar = true
            // item.count = 0
          } else {
            if (this.$route.name !== 'presaleEdit' && item.product && this.priceType === 'formulaPrice') {
              if (this.type === 'sell' || this.type === 'presale') {
                this.getPrice(item)
              }
            }
            if (this.type === 'returnSell') {
              this.getPrice(item)
            }
          }
        }
        this.calcSum()
      },
      removegroup () {
        var app = this
        app.selected.map(function (value, key) {
          app.remove(value, key)
        })
      },
      onTableUpdate (value) {
        this.compositeTableData = value
      },
      create () {
        if (!this.$refs.form.validate()) return false
        // this.items.map(function (value, index) {
        //   if (!value.product) {
        //     this.remove(value, index)
        //   }
        // })
        var app = this
        app.snakbar = false
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'invoice', this.$data)
          .then(res => {
            res = res.data
            if (res.status === 'success') {
              app.snakbarText = app.$t('registered')
              app.snakbarColor = 'green'
              app.snakbar = true
              if (app.$refs.refFilePicker !== undefined && app.attachments) {
                app.$refs.refFilePicker.create(res.data.id)
              }
              app.$emit('close', app.$route)
              app.clearForm()
              if (app.type === 'sell' || app.type === 'presale') {
                if (app.printType === 'normal') {
                  app.$router.push({ name: 'invoicePrint', params: { id: res.data.uid } })
                } else {
                  app.$router.push({ name: 'invoiceRollprint', params: { id: res.data.uid } })
                }
              } else {
                app.goTo(app.type + 'List')
              }
            } else {
              app.snakbarText = app.$t('error')
              app.snakbarColor = 'pink'
              app.snakbar = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
          this.isInvoiceCreated = true
      },
      update () {
        var app = this
        app.snakbar = false
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'invoice/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            if (app.$refs.refFilePicker !== undefined) {
              app.$refs.refFilePicker.create(res.data.id)
            }
            app.$emit('close', app.$route)
            app.clearForm()
            app.goTo(app.type + 'List')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.watcher = false
        app.$axios.get(this.$endpoint + 'invoice/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.id = res.id
              app.currency = res.currency
              app.decimal = (res.currency ? res.currency.decimal : 0)
              app.currency_amount = res.currency_amount
              app.number = res.number
              app.officialNumber = res.official_number
              app.content = res.content
              app.customFields = res.custom_fields
              app.pattern = res.pattern
              app.invoicePattern = res.invoicePattern
              app.contractNumber = res.contractNumber
              app.date = res.date
              app.refInvoice = res.refInvoice
              app.given = res.given
              app.type = res.type
              app.items = res.article
              app.notifications = res.notifications
              app.account = res.customer
              app.attachments = res.attachments
              app.editCompositeTableData = [...res.compositeTableData]
              app.entrepot = (res.entrepot ? res.entrepot.entrepot : null)
              app.dueDate = res.due_date
              app.branch = res.branch
              app.payments = res.payments
              app.seller = res.seller
              app.commissionAmount = res.commissionAmount
              app.checks = res.checks
              app.status = (res.last_status ? res.last_status.status : null)
              app.discount = res.discount
              app.plan = (res.plan ? res.plan.plan : null)
              app.compositeTableData = res.compositeTableData
              app.totalDiscount = res.discount
              app.investors = (res.entrepot && res.entrepot.investors ? res.entrepot.investors : null)
              app.items.map(function (value, index) {
                if (value.discount && value.discount > 0) {
                  app.checkDiscountEdit = true
                }
              })
              if (!app.checkDiscountEdit) {
                app.discountEdit = res.discount
              }
              // app.totaltax = res.tax
              if (res.tax > 0) {
                app.taxStatus = 'active'
                app.taxPercent = res.tax_percent
              }



              if (res.tags) {
                app.tag = res.tags
                app.more = true
              }
              if (!this.entrepot && res.entrepotIntegrator) {
                this.entrepot = res.entrepotIntegrator
              }
              setTimeout(function () {
                app.render = true
              }, 1000)
              setTimeout(function () {
                app.watcher = true
              }, 3000)
              app.calcSum()
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearForm () {
        this.selected = []
        this.render = true
        this.watcher = false
        this.bodyStatus = false
        this.printDialog = false
        this.deletDialog = false
        this.showClearing = true
        this.showSelect = false
        this.showProductList = false
        this.clearingStatus = false
        this.filter = false
        this.valid = true
        this.number = null
        this.invoicePattern = 1
        this.contractNumber = null
        this.pattern = 1
        this.bank = null
        this.given = null
        this.attachments = null
        this.investors = null
        this.payments = null
        this.seller = null
        this.commissionPercent = null
        this.commissionAmount = null
        this.checks = null
        this.officialNumber = null
        this.account = null
        this.dueDate = null
        this.editCompositeTableData = []
        this.compositeTableData = []
        // this.date = null
        // this.currency_amount = null
        this.content = null
        this.model = null
        this.from = 1
        this.taskDialog = null
        this.id = null
        this.status = null
        this.tag = null
        this.temp = null
        this.deleteItem = null
        this.sellStatus = null
        this.items = []
        this.dialog = null
        this.timer = 0
        this.isLoading = false
        this.snakbar = false
        this.taskId = null
        this.snakbarText = null
        this.loading = false
        this.search = null
        this.discountPercent = false
        this.taxStatus = false
        this.totalCount = 0
        this.discount = 0
        this.totalDiscount = 0
        this.totalTax = 0
        this.totalFee = 0
        this.sumRow = 0
        this.sum = 0
        this.totalDiscountType = false
        this.getInvoiceNumber()
        this.addRow()
        this.$refs.form.resetValidation()
      },
      openOptionsDialog (value) {
        this.optionDialogType = value
      },
      totalAmount (value) {
        this.totalPayment = value
      },
      invoiceRemain (value) {
        this.remainInvoice = value
      },
      selectTaxOption (item) {
        this.selectedTaxOption = item.value
        if (item.value == 'active') {
          this.taxStatus = 'active'
        } else {
          this.taxStatus = 'deactive'
        }
      },
      checkTaxStatus () {
        if (this.totalTax == 0) {
          this.selectedTaxOption = 'deactive'
          this.taxStatus = 'deactive'
        } else {
          this.selectedTaxOption = 'active'
          this.taxStatus = 'active'
        }
      }
    },
  }
</script>

<style scoped>
.wrapper .description {
  height: 45px !important;
  border: 1px solid silver;
  margin-bottom: 0;
  margin: 0 !important;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__control .v-input__slot .v-text-field__slot textarea {
  height: 25px !important;
  overflow: auto !important;
  margin-top: 7px;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar {
  display: none;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__append-outer {
  margin-top: 11px;
  margin-left: 10px;
}
.header-total {
  border: 1.5px solid #0066ff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 7px 10px;
}
.v-card__text {
  width: auto;
}
.body-total {
  border: 1.5px solid silver;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.discount ::v-deep .v-input__control .v-input__slot {
  width: 90px;
}
.discount ::v-deep .v-input__control .v-input__slot.white {
  width: 100%;
}
::v-deep .v-input--selection-controls .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
}
::v-deep .v-messages {
  display: none;
}
::v-deep .v-input--selection-controls.v-input--checkbox {
  margin: 0 !important;
  padding: 0;
}
.wrapper-toggle-tax {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle-tax .child {
  padding: 7.5px;
  cursor: pointer;
}
.wrapper-toggle-tax .child:first-child {
  border-left: 1px solid silver;
}
</style>
